export default __webpack_public_path__ + "static/media/bok.b51ae86a.png";